import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfile, saveFeedback } from "../backend";
import { useAuth } from "../context/AuthContext";
import uiStyles from "../theme/uiStyles";

export default function Feedback() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadProfile() {
      if (!user?.uid) {
        setEmail(user?.email || "");
        return;
      }

      try {
        const profile = await getProfile(user.uid);
        const fullName = [profile?.firstName, profile?.lastName]
          .filter(Boolean)
          .join(" ");

        setName(fullName);
        setEmail(profile?.email || user.email || "");
      } catch {
        setEmail(user?.email || "");
      }
    }

    loadProfile();
  }, [user?.uid, user?.email]);

  const handleSubmit = async () => {
    if (!name.trim() || !message.trim()) {
      setError("Please add your name and feedback.");
      setStatus("");
      return;
    }

    setSubmitting(true);
    setError("");
    setStatus("");

    try {
      await saveFeedback({
        name: name.trim(),
        email: email.trim(),
        message: message.trim(),
        userId: user?.uid || null,
        createdAt: new Date(),
        status: "new"
      });

      setStatus("Thanks for the feedback. We saved it for internal review.");
      setMessage("");
    } catch (submitError) {
      setError("Unable to send feedback right now.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={uiStyles.page}>
      <div style={styles.pageHeader}>
        <button style={styles.homeBtn} onClick={() => nav("/home")}>
          Home
        </button>
      </div>

      <div style={uiStyles.card}>
        <div style={styles.headerRow}>
          <h2 style={{ marginTop: 0, marginBottom: 0 }}>Feedback</h2>
        </div>
        <p style={styles.subtle}>
          Share bugs, ideas, or anything that would make NextBite better.
        </p>

        <input
          style={uiStyles.input}
          placeholder="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <input
          style={uiStyles.input}
          placeholder="Email (optional)"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <textarea
          style={styles.textarea}
          placeholder="Tell us what you think"
          rows={6}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        {status && <p style={styles.success}>{status}</p>}
        {error && <p style={styles.error}>{error}</p>}

        <button
          style={uiStyles.primaryBtn}
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? "Sending..." : "Send Feedback"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  pageHeader: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 12
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 12
  },
  subtle: {
    marginTop: 0,
    color: "#64748b"
  },
  homeBtn: {
    padding: "10px 16px",
    borderRadius: 999,
    border: "1px solid #f0d9d1",
    background: "rgba(255,255,255,0.85)",
    color: "#7c3d2e",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600
  },
  textarea: {
    width: "100%",
    minHeight: 140,
    resize: "vertical",
    padding: 12,
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    outline: "none",
    fontSize: 14,
    background: "#fff",
    boxSizing: "border-box"
  },
  success: {
    margin: 0,
    color: "#166534",
    fontSize: 14
  },
  error: {
    margin: 0,
    color: "#dc2626",
    fontSize: 14
  }
};
